export function changeToken(perfil) {
  return {
    type: "@auth/CHANGE_TOKEN",
    payload: { perfil },
  };
}

export function signInRequest(email, senha, noRedirect, setLogged, navigate) {
  return {
    type: "@auth/SIGN_IN_REQUEST",
    payload: { email, senha, noRedirect, navigate },
    setLogged : setLogged
  };
}

export function changePerfis(auth) {
  return {
    type: "@auth/CHANGE_PERFIS",
    payload: { auth },
  };
}

export function signInSucces({ usuario, perfis, perfil, preferencias }) {
  return {
    type: "@auth/SIGN_IN_SUCCESS",
    payload: { usuario, perfis, perfil, preferencias },
  };
}

export function signUpRequest(name, email, senha) {
  return {
    type: "@auth/SIGN_UP_REQUEST",
    payload: { name, email, senha },
  };
}

export function signFailure(options) {
  const { preferencias } = options || {};

  return {
    type: "@auth/SIGN_IN_FAILURE",
    payload: { preferencias },
  };
}

export function signOut() {
  return {
    type: "@auth/SIGN_OUT",
  };
}